type IconProps = {
    size?: number;
    color?: string;
}

export const DownloadIcon = (props:IconProps) => {
	const { size = 24, color = 'var(--brand-navy-default)' } = props;
	return (
		<svg role={'img'} width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6Z' fill={color}/>
		</svg>
	);
}
